import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { appVariables } from '../../helpers/appVariables';
import { helmetJsonLdProp } from "react-schemaorg";
// import { Organization } from "schema-dts";

function LottoHelmetOthers({ gamegroupID }) {

    let dd = [
        helmetJsonLdProp({
            "@context": "http://www.schema.org",
            "@graph": [
                {
                    "@type": "BreadcrumbList",
                    itemListElement: [{ "@type": "ListItem", "position": 1, "name": "Home" }]
                },
                {
                    "@type": "FAQPage",
                    "mainEntity": [
                        {
                            "@type": "Question",
                            "name": "What is the online draw website?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "Our online draw website is an online platform that allows users to participate in various online draw games and have a chance to win exciting prizes"
                            }
                        }
                    ]
                },
                {
                    "@type": "WebSite",
                    name: "Gulf Ticket ",
                    alternateName: "Gulf Ticket India",
                    url: process.env.REACT_APP_DESKTOP_URL,
                    // "@id": "https://gulfticket.com/#website",
                    description: "sharing million smiles with Gulf Ticket"
                }
            ]
        })
    ]

    let dd1 = [helmetJsonLdProp({
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "BreadcrumbList",
                // "@id": "https://gulfticket.com/#breadcrumb",
                itemListElement: [{ "@type": "ListItem", "position": 1, "name": "Lucky1" }]
            },
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What is Lucky 1 ?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Lucky1 is an exciting online draw game offered by GulfTicket. Players choose 1 Zodiac sign out of 12 for a chance to win attractive prizes."
                        }
                    }
                ]
            },
            {
                "@type": "WebSite",
                "name": "Gulf Ticket",
                "url": "https://gulfticket.com/lucky1",
                "logo": {
                    "@type": "ImageObject",
                    "url": "https://gulfticket.com/assets/img/logo.png?v0.3"
                },
                "sameAs": [
                    "https://www.facebook.com/gulfticketindia/",
                    "https://www.youtube.com/@gulfticket",
                    "https://x.com/gulfticketindia"
                ],
                "description": "Unleash your chance to win millions with Gulf Ticket, the UAE's premier online raffle draw. Experience the thrill of life-changing possibilities and become a part of our winning community.",
                "keywords": "Gulf Ticket, online raffle draw, UAE raffle draw, Gulf Ticket millionaire draw, best online raffle draw in the UAE, how to play Gulf Ticket, Gulf Ticket lottery prizes, Gulf Ticket results, Gulf Ticket winner stories, Gulf Ticket reviews, Gulf Ticket promo codes, Gulf Ticket contact information, online raffle Dubai, how to play Gulf Ticket online, Gulf Ticket schedule and results, best strategies for winning Gulf Ticket Lottery"
            }]
    })
    ]

    return (
        <div>
            {gamegroupID == 1 ? <Helmet script={dd}>
                <title>Play Lotto – Buy Tickets Online</title>
                <meta name="description" content="Enter the draw with Play Lotto. Buy tickets online securely, check results fast, and claim winnings with a simple process." />
                <meta name="keywords" content="Play Lotto lottery" />
                <meta property="og:title" content={`Gulf Ticket's Play Lotto: Your Gateway to USD ${appVariables.PRIZE_STRUCT_PLAYLOTTO.MainDrawWin.FstPrize} Million for USD ${appVariables.PRIZE_STRUCT_PLAYLOTTO.BetAmount}`} />
                <meta property="og:site_name" content="Gulf Ticket" />
                <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                <meta property="og:description" content="Enter the draw with Play Lotto. Buy tickets online securely, check results fast, and claim winnings with a simple process." />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://gulfticket.com/assets/img/gamesBg/play-lotto.png?v0.3" />
            </Helmet > : gamegroupID == 2 ? <Helmet script={{ dd }}>
                {/* <title>Gulf Ticket's Super 6: Your Chance to Win AED {appVariables.PRIZE_STRUCT_SUPER6.MainDrawWin.FstPrize} Million for AED {appVariables.PRIZE_STRUCT_SUPER6.BetAmount}</title> */}
                <title>Play Mini Lotto | Secure Online Lotto</title>
                <meta name="description" content="Play Mini Lotto lotto for a chance at big jackpots. Safe purchase, quick results, and transparent prize tiers." />
                <meta name="keywords" content="Mini Lotto  lottery" />

                <meta property="og:title" content={`Gulf Ticket's Mini lotto: Your Gateway to USD ${appVariables.PRIZE_STRUCT_MINILOTTO.MainDrawWin.FstPrize}  for AED ${appVariables.PRIZE_STRUCT_MINILOTTO.BetAmount}`} />
                <meta property="og:site_name" content="Gulf Ticket" />
                <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                <meta property="og:description" content="Play Mini Lotto lotto for a chance at big jackpots. Safe purchase, quick results, and transparent prize tiers." />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://gulfticket.com/assets/img/gamesBg/mini-lotto.png?v0.3" />
            </Helmet > : gamegroupID == 3 ? <Helmet script={dd}>
                {/* <title>Gulf Ticket's Magic 5: Your Chance to Win AED {appVariables.PRIZE_STRUCT_MAGIC5.MainDrawWin.FstPrize} for AED {appVariables.PRIZE_STRUCT_MAGIC5.BetAmount}</title> */}
                <title>Fast Lotto Lotto – Big Jackpots Await</title>
                <meta name="description" content="Join Fast Lotto: easy ticket purchase, scheduled draws, and clear odds. See results instantly and withdraw securely." />
                <meta name="keywords" content="Fast Lotto lottery" />
                <meta property="og:title" content={`Gulf Ticket's Fast Lotto: Your Gateway to USD ${appVariables.PRIZE_STRUCT_FASTLOTTO.MainDrawWin.FstPrize}  for USD ${appVariables.PRIZE_STRUCT_FASTLOTTO.BetAmount}`} />
                <meta property="og:site_name" content="Gulf Ticket" />
                <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                <meta property="og:description" content="Join Fast Lotto: easy ticket purchase, scheduled draws, and clear odds. See results instantly and withdraw securely." />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://gulfticket.com/assets/img/gamesBg/fast-lotto.png?v0.3" />
            </Helmet > : gamegroupID == 4 ? <Helmet script={dd}>
                <title>Millionaire Lotto – Fast Draws, Easy Wins</title>
                <meta name="description" content="Try Millionaire Lotto—simple rules, flexible ticket options, and fast result announcements. Start playing today." />

                <meta name="keywords" content="Millionaire Lotto lottery" />
                
                <meta property="og:title" content="Experience the thrill of becoming a Gulf Ticket Millionaire Lotto millionaire with a staggering USD 10,00,000 prize for just USD 1.5." />
                <meta property="og:site_name" content="Gulf Ticket" />
                <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                <meta property="og:description" content="Try Millionaire Lotto—simple rules, flexible ticket options, and fast result announcements. Start playing today." />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://gulfticket.com/assets/img/gamesBg/millionaire-lotto.png?v0.3" />
            </Helmet > :
                gamegroupID == 5 ? <Helmet script={dd1}>
                    <title>Buy Multi Million Lotto Tickets | Play Today</title>
                    <meta name="description" content="With Multi Million Lotto, buying lotto tickets is easy and secure. Track draws, view results, and claim prizes quickly." />
                    <meta name="keywords" content="Multi Million Lotto lottery" />
                    <meta property="og:title" content="Experience the thrill of becoming a Gulf Ticket Millionaire Lotto millionaire with a staggering USD 30,00,000 prize for just USD 3." />
                    <meta property="og:site_name" content="Gulf Ticket" />
                    <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                    <meta property="og:description" content="With Multi Million Lotto, buying lotto tickets is easy and secure. Track draws, view results, and claim prizes quickly." />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://gulfticket.com/assets/img/gamesBg/muliti-millions-lotto.png?v0.3" />
                </Helmet > :
                    gamegroupID == 6 ? <Helmet script={dd}>
                        <title>Super Mega Million Lotto – Buy Tickets Online</title>
                        <meta name="description" content="Enter the draw with Super Mega Million Lotto. Buy tickets online securely, check results fast, and claim winnings with a simple process." />
                        <meta name="keywords" content="Super Mega Million Lotto lottery" />
                        <meta property="og:title" content="Experience the thrill of becoming a Gulf Ticket Millionaire Lotto millionaire with a staggering USD 2,50,00,000 prize for just USD 10." />
                        <meta property="og:site_name" content="Gulf Ticket" />
                        <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                        <meta property="og:description" content="Enter the draw with Super Mega Million Lotto. Buy tickets online securely, check results fast, and claim winnings with a simple process." />
                        <meta property="og:type" content="website" />
                        <meta property="og:image" content="https://gulfticket.com/assets/img/gamesBg/super-mega-lotto.png" />
                    </Helmet > :
                        <Helmet script={dd}>
                            <title >Gulf Ticket: Your Gateway to Millionaire Dreams</title>
                            <meta name="description" content="Unleash your chance to win millions with Gulf Ticket, the UAE's premier online raffle draw. Experience the thrill of life-changing possibilities and become a part of our winning community." />
                            <meta name="keywords" content="Gulf Ticket, online raffle draw, UAE raffle draw, Gulf Ticket millionaire draw, best online raffle draw in the UAE, how to play Gulf Ticket, Gulf Ticket lottery prizes, Gulf Ticket results, Gulf Ticket winner stories, Gulf Ticket reviews, Gulf Ticket promo codes, Gulf Ticket contact information, online raffle Dubai, how to play Gulf Ticket online, Gulf Ticket schedule and results, best strategies for winning Gulf Ticket Lottery" />
                            <meta property="og:title" content="Gulf Ticket: Your Gateway to Millionaire Dreams" />
                            <meta property="og:site_name" content="Gulf Ticket" />
                            <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                            <meta property="og:description" content="Unleash your chance to win millions with Gulf Ticket, the UAE's premier online raffle draw. Experience the thrill of life-changing possibilities and become a part of our winning community." />
                            <meta property="og:type" content="website" />
                            <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                        </Helmet>}
        </div>
    );
}

export default LottoHelmetOthers;
